import * as React from 'react';
import * as classNames from "classnames";
import { IPlotBadgeProps } from "../PlotBadgeContainer";

class PlotBadge extends React.PureComponent<IPlotBadgeProps, any> {

    constructor(props, context) {
        super(props, context);

    }

    render() {
        const { plot, referencePlotStatus } = this.props;

        const currentPlotStatus = plot ? plot.plotStatus : undefined;

        if(referencePlotStatus && referencePlotStatus.length > 0 && currentPlotStatus && currentPlotStatus.code)
        {
            switch(currentPlotStatus.code){
                case "ACTIVE":
                    return <div className={classNames(this.props.className, "badge badge-success")}>{referencePlotStatus.find(p => p.code == "ACTIVE").label}</div>;
                case "INACTIVE":
                    return <div className={classNames(this.props.className, "badge badge-danger")}>{referencePlotStatus.find(p => p.code == "INACTIVE").label}</div>;
                case "EVALUATING":
                    return <div className={classNames(this.props.className, "badge badge-info")}>{referencePlotStatus.find(p => p.code == "EVALUATING").label}</div>;
                default:
                    return <div className={classNames(this.props.className, "badge badge-warning")}>Other</div>;

            }
        }

        return <div className="badge badge-secondary">Unknown</div>;
    }
}

export default PlotBadge;
